export default "__VITE_ASSET__ghBI4g4i__"